import React from 'react';
import './LandingPage.css';
import appImage1 from './image/app-image1.png'; // Import your app image
import appStoreBadge from './image/download-on-the-app-store.svg'; // Import App Store badge
import playStoreBadge from './image/google-play-badge.png'; // Import Play Store badge
import nunLogoFilled from './image/nunlogofilled.png'; // Import Play Store badge

function LandingPage() {
  return (
    <div className="LandingPage">
      <header className="LandingPage-header">
        <div className="Content">
          <div className="Text">
          <img src={nunLogoFilled} alt="Mutabaah Logo" className="logo-image" />
            <h1>Empowering Quran Memorization Program</h1>
            <p>Digital Solution for Monitoring and Improving the Progress of Memorization of Quranic Students in Quran Memorization Halaqoh</p>
            <p>Solusi Digital untuk Memantau dan Meningkatkan Progres Hafalan Santri dalam Halaqoh Tahfidz Quran</p>
            <div className="Download-buttons">
              <a href="https://apps.apple.com/id/app/mutabaah/id6463693463" target="_blank" rel="noopener noreferrer">
                <img src={appStoreBadge} alt="Download on the App Store" />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.noon.mutabaahjetpack&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">
                <img src={playStoreBadge} alt="Get it on Google Play" />
              </a>
            </div>
          </div>
          <div className="Images">
            <img src={appImage1} alt="App Screenshot 1" style={{ width: "100%", height: "auto" }}/>
          </div>
        </div>
      </header>
    </div>
  );
}

export default LandingPage;
